export const SET_DEFAULT_BUILDING = 'buildings/SET_DEFAULT_BUILDING';